import { MapMarkerCircleIcon } from './MapMarkerCircleIcon';

/**
 * author: Google
 * id 03F79839-314C-4F29-B3E3-43B97D7F7FA6
 * name map-marker-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-circle.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationCircleIcon = MapMarkerCircleIcon;
export default LocationCircleIcon